import { useContext } from 'react';
import { Button } from '@chakra-ui/react';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { toast } from '@duke-hq/app-admin-web/components/ToastContainer';
import { useOptimisticPublishTranslations } from '../components/translations/useOptimisticPublishTranslations';
import { useResourceByQueryId } from '../hooks';
import { PageEditorStateContext } from '../components/ReactFlow/PageEditorStateContext';
import { usePublishEditorSetting } from '../state/editorSettingsState';

export function PagePublishButton() {
  const resourceQuery = useResourceByQueryId();
  const writeOptimisticTranslations = useOptimisticPublishTranslations();
  const utils = trpcAdmin.useUtils();
  const publish = trpcAdmin.resourceVersions.publish.useMutation();
  const { mutateAsync: publishEditorSettings } = usePublishEditorSetting();

  const { resourceSettings, setLastPublishedResourceVersion } = useContext(PageEditorStateContext);

  const updateResourceSettings = trpcAdmin.resources.update.useMutation();

  return (
    <Button
      variant="primary"
      size="sm"
      onClick={async () => {
        const draftVersion = resourceQuery.data?.draftVersion;

        if (resourceSettings?.id) {
          await updateResourceSettings.mutateAsync({
            id: resourceSettings.id,
            title: resourceSettings?.title,
            created_by: resourceSettings.created_by,
            visibility: resourceSettings.visibility,
            identifier: resourceSettings.identifier || undefined,
          });
        }
        await publishEditorSettings();
        if (draftVersion) {
          const res = await publish.mutateAsync({
            resourceVersionId: draftVersion.id,
            baseRevision: draftVersion.revision,
          });
          const resourceId = resourceQuery.data?.id;
          if (resourceId != null) {
            setLastPublishedResourceVersion({ id: res.id, resourceId });
            // Refetch so the badge clears "Unpublished changes" and the translations pill
            // repoints; the conversation editor does the same on publish.
            void utils.resources.byId.invalidate(resourceId);
          }
          // Write optimistic PENDING rows for the new version so the toolbar dot
          // and panel begin streaming in straight away, then resume the poll to
          // reconcile with the server's real per-language rows.
          writeOptimisticTranslations(res.id, 'PAGE');
          toast({
            status: 'success',
            title: `Version ${res.version} published`,
          });
        }
      }}
      isLoading={publish.isPending}
    >
      Publish
    </Button>
  );
}
